/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Map_Search_ClearInputs */

const vi_map_search_clear = /** @type {(inputs: Map_Search_ClearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Xoá tìm kiếm`)
};

/**

* @param {Map_Search_ClearInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const map_search_clear = /** @type {((inputs?: Map_Search_ClearInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Map_Search_ClearInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_map_search_clear(inputs)
});